// extracted by mini-css-extract-plugin
export default {"container":"createRoleForm_container__PUej+","createButton":"createRoleForm_createButton__8g2Fe"};